
export const checkPasswordStrength = (password) => {
    if(password === undefined) {
        return false;
    }
    if(password.length < 8) {
        return false;
    }

    var numbers = /\d/;
    if(!numbers.test(password)) {
        return false;
    }

    var specialChars = /[^A-Za-z 0-9]/g;
    if(!specialChars.test(password)) {
        return false;
    }
    return true;
}


// WEBPACK FOOTER //
// ./src/password_strength.js